import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { styled } from '@mui/system';
import KeyboardArrowDownSharpIcon from '@mui/icons-material/KeyboardArrowDownSharp';

const StyledAutocomplete = styled(Autocomplete)(({ borderTab = false }) => ({
  '& .MuiOutlinedInput-root': {
    border: 'none',
    padding: '8px 16px',
    '& fieldset': {
      border: 'none',
    },
    '&:hover fieldset': {
      border: 'none',
    },
    '&.Mui-focused fieldset': {
      border: 'none',
    },
    backgroundColor: 'transparent',
  },
  '& .MuiAutocomplete-input': {
    padding: borderTab ? '10px 0' : '8px 0',
    maxWidth: borderTab ? 'auto' : '120px',
  },
  '& .MuiAutocomplete-endAdornment': {
    right: '8px',
  },
}));

const StyledTextField = styled(TextField)(({ highLight, highLightColor, borderTab = false }) => ({
  '& .MuiInputLabel-root': {
    backgroundColor: '#fafafa',
    padding: '0 5px',
    marginLeft: '-0.5rem',
    color: '#2e2e2e',
    fontFamily: 'Gotham',
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '26px',
    '&.Mui-focused': {
      color: '#2E2E2E',
    },
  },
  '& .MuiInputBase-input': {
    color: highLight ? highLightColor : '#000',
    padding: '8px 16px',
    paddingLeft: borderTab ? '1rem' : '16px',
    fontSize: '14px',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
}));

const SearchableSelect = ({
  value = null,
  label,
  handleChange,
  placeholder = 'Select',
  disabled = false,
  options = [],
  className,
  error,
  messages,
  required = false,
  highLight,
  highLightColor,
  borderTab = false,
  icon: Icon = KeyboardArrowDownSharpIcon,
  onFocus, onBlur,
}) => {
  return (
    <div className={className}>
      <StyledAutocomplete
        disablePortal
        disabled={disabled}
        options={options}
        getOptionLabel={(option) => option.label || ''}
        value={options.find((opt) => opt.value === value) || null}
        onChange={(event, newValue) => handleChange(newValue?.value || '')}
        borderTab={borderTab}
        popupIcon={<Icon />}
        disableClearable
        forcePopupIcon={true}
        onFocus={onFocus}
        onBlur={onBlur}
        PaperProps={{
          style: {
            border: 'none',
            boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.2)',
          },
        }}
        renderInput={(params) => (
          <StyledTextField
            {...params}
            label={`${label}${required ? ' *' : ''}`}
            placeholder={placeholder}
            variant="outlined"
            fullWidth
            error={!!error}
            helperText={messages}
            highLight={highLight}
            highLightColor={highLightColor}
            borderTab={borderTab}
          />
        )}
        renderOption={(props, option) => (
          <li {...props} key={option.value}>
            {option.label}
          </li>
        )}
      />
    </div>
  );
};

export default SearchableSelect;